import { isInTimeWindow } from "@/utils/date-utils";

import { ActivationStatus } from "../pages/ActivityDetails/types";

// Used to convert @param deletedAt into activity or user status
export function convertActivationStatus(
  deletedAt?: string | null,
  startOn?: Date,
  endOn?: Date
): ActivationStatus {
  const isActive = !deletedAt && isInTimeWindow(new Date(), startOn, endOn);
  return isActive ? "Active" : "Deactivated";
}
